import DefaultFormat from './default_format.helper'

export default class KiPlannerFormat extends DefaultFormat {}
